import _ from "lodash";

export class NPSDataFormat {
    constructor({ NPSGateway } = {}) {
        this.NPSGateway = NPSGateway;

        this.accountingId = "";

        this.quarterToMonth = { 1: "03", 2: "06", 3: "09", 4: "12" };
        this.seriesPointPath = {
            nps: { path: "score", separator: "-" },
            npsScore: { path: "score", separator: "/" },
            npsPromoters: { path: "promoters", separator: "/" },
            sent: { path: "sent", separator: "/" },
            answeredRating: { path: "answeredRating", separator: "/" },
            received: { path: "received", separator: "/" },
            opened: { path: "opened", separator: "/" },
            answered: { path: "answered", separator: "/" },
            commented: { path: "commented", separator: "/" },
            npsRecommendations: { path: "recommendations", separator: "/" },
            npsPercentageRecommendations: {
                path: "rateRecommendations",
                separator: "/"
            }
        };
    }

    setAccountingId(accountingId) {
        this.accountingId = accountingId;
    }

    _formatPoint({ point, serie }) {
        const defaultSerieConfig = {
            path: serie,
            separator: "-"
        };

        const serieConfig = this.seriesPointPath[serie] || defaultSerieConfig;

        const period = {
            year: point.period.year,
            quarter: point.period.quarter
        };
        const pointResponse = {
            t: new Date(
                `${period.year}${serieConfig.separator}${
                    this.quarterToMonth[period.quarter]
                }${serieConfig.separator}01`
            ),
            s: serie,
            c: "EMPRESA_NUCONT",
            sc: "ORIGINAL",
            u: new Date(),
            m: {
                v: _.get(point, `${serieConfig.path}`) || 0
            },
            metadata: {},
            period: "quarterly"
        };

        return pointResponse;
    }

    getPoints({ chart, series, year, quarter }) {
        const points = [];

        const pointsResponse = this.getData({ chart, year, quarter });

        for (const point of pointsResponse) {
            for (const serie of series) {
                const pointFormatted = this._formatPoint({
                    point,
                    serie
                });

                points.push(pointFormatted);
            }
        }

        return _.sortBy(points, "t");
    }

    getData({ chart, year, quarter }) {
        const charts = {
            nps: () => {
                const selector = {
                    "nps.accountingId": this.accountingId,
                    "period.tNumber": { $lte: Number(`${year}${quarter}`) }
                };

                const response = this.NPSGateway.findCollection(
                    selector,
                    { limit: Infinity },
                    "array"
                );

                return response;
            },
            emailsEvents: () => {
                const selector = {
                    "nps.accountingId": this.accountingId,
                    "period.tNumber": { $lte: Number(`${year}${quarter}`) }
                };

                const npsList = this.NPSGateway.findCollection(
                    selector,
                    {},
                    "array"
                );

                const points = [];

                for (const nps of npsList) {
                    const total = {
                        sent: 0,
                        received: 0,
                        opened: 0,
                        answered: 0,
                        commented: 0,
                        period: nps.period,
                        answeredRating: 0
                    };

                    for (const rating of nps.nps.ratings) {
                        if (rating.events.sent) total.sent++;
                        if (rating.events.received) total.received++;
                        if (rating.events.opened) total.opened++;
                        if (rating.events.answered) total.answered++;
                        if (rating.events.commented) total.commented++;
                    }

                    total.answeredRating = (total.answered / total.sent) * 100;

                    points.push(total);
                }

                return points;
            },
            promotersPassivesDetractors: () => {
                const selector = {
                    "nps.accountingId": this.accountingId,
                    "period.tNumber": { $lte: Number(`${year}${quarter}`) }
                };

                const response = this.NPSGateway.findCollection(
                    selector,
                    { limit: Infinity },
                    "array"
                );

                return response;
            },
            npsHistoric: () => {
                const selector = {
                    "nps.accountingId": this.accountingId,
                    "period.tNumber": { $lte: Number(`${year}${quarter}`) }
                };

                const response = this.NPSGateway.findCollection(
                    selector,
                    { limit: Infinity },
                    "array"
                );

                return response;
            },
            npsRecommendations: () => {
                const selector = {
                    "nps.accountingId": this.accountingId,
                    "period.tNumber": { $lte: Number(`${year}${quarter}`) }
                };

                const response = this.NPSGateway.findCollection(
                    selector,
                    { limit: Infinity },
                    "array"
                );

                return response;
            },
            npsRateRecommendations: () => {
                const selector = {
                    "nps.accountingId": this.accountingId,
                    "period.tNumber": { $lte: Number(`${year}${quarter}`) }
                };

                const response = this.NPSGateway.findCollection(
                    selector,
                    { limit: Infinity },
                    "array"
                );

                if (!response) return [];

                const npsList = this._setRateRecommendations(response || []);

                return npsList || [];
            }
        };

        if (charts[chart]) return charts[chart]();
    }

    _setRateRecommendations(npsList) {
        return npsList.map((nps) => {
            const allRatings = _.get(nps, "nps.ratings") || [];

            const ratingsWithRecommendations = allRatings.filter(
                (r) => r.recommendations && r.recommendations.length
            );

            return {
                ...nps,
                rateRecommendations:
                    (ratingsWithRecommendations.length / allRatings.length) *
                    100
            };
        });
    }
}
